export default __webpack_public_path__ + "static/proper-details-top-video-t-c759c3a5630557cfc5c66b86094dee8f.jpg";